const createHeroIcon = (pathNodes = [], baseStrokeWidth = "1.8") => ({
  functional: true,
  render(h, ctx) {
    const data = {
      ...ctx.data,
      attrs: {
        ...(ctx.data && ctx.data.attrs ? ctx.data.attrs : {}),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": baseStrokeWidth,
        stroke: "currentColor"
      }
    };

    return h(
      "svg",
      data,
      pathNodes.map((node) =>
        h("path", {
          attrs: node
        })
      )
    );
  }
});

export const HeroPlusCircle = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }
]);

export const HeroMagnifyingGlass = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m21 21-4.35-4.35m0 0A7.5 7.5 0 1 0 6.75 6.75a7.5 7.5 0 0 0 9.9 9.9Z"
  }
]);

export const HeroXMark = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18 18 6M6 6l12 12"
  }
]);

export const HeroEye = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178Z"
  },
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  }
]);

export const HeroChartBar = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M3 3v18h18M7.5 14.25 10.5 11l2.25 2.25L16.5 9"
  }
]);

export const HeroTrash = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0C9.16 2.313 8.25 3.296 8.25 4.476v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
  }
]);

export const HeroListBullet = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M3.75 6.75h16.5m-16.5 5.25h16.5m-16.5 5.25h16.5"
  }
]);

export const HeroClock = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6l3.75 2.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }
]);

export const HeroCheckCircle = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }
]);

export const HeroXCircle = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9.75 9.75 14.25 14.25m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }
]);

export const HeroBars3 = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M3.75 6.75h16.5m-16.5 5.25h16.5m-16.5 5.25h16.5"
  }
]);

export const HeroArrowRightOnRectangle = createHeroIcon(
  [
    {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h5a2 2 0 012 2v1"
    }
  ],
  "2"
);

export const HeroArrowLeft = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M7 12h10m0 0-4-4m4 4-4 4"
  }
]);

export const HeroArrowDownTray = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16"
  }
]);

export const HeroUser = createHeroIcon([
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.75 6.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
  },
  {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4.5 20.118a7.5 7.5 0 0 1 15 0A17.933 17.933 0 0 1 12 21.75a17.933 17.933 0 0 1-7.5-1.632Z"
  }
]);